var React = require('react');

function ArrowAltUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160,456V256H288.11V456a24,24,0,0,1-24,24H184A24,24,0,0,1,160,456Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M39.05,215,207,39a24.08,24.08,0,0,1,34,0L408.92,215c15.11,15.09,4.4,41-17,41H56.05C34.63,256,24,230.3,39.05,215Z","className":"fa-primary","key":2})]);
}

ArrowAltUp.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ArrowAltUp;

ArrowAltUp.default = ArrowAltUp;
